import cn from 'classnames';
import banksIcon from '../../../assets/image/banks_icon.png';

interface IProps {
  selected: boolean;
  onSelect: () => void;
}

const InternetPay = ({selected, onSelect}: IProps) => {
  return (
    <div
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={e => e.key === 'Enter' && onSelect()}
      className={cn(
        'p-4 text-sm border rounded-xl cursor-pointer transition',
        'shadow-sm bg-white',
        selected
          ? 'border-farm-shop-500 ring-2 ring-farm-shop-500'
          : 'border-gray-50',
      )}
    >
      <div className="flex items-center gap-2">
        <input
          type="radio"
          checked={selected}
          readOnly
          className="scale-125 accent-farm-shop-500"
        />
        <span className="mr-3 font-medium text-zinc-900">پرداخت اینترنتی</span>
      </div>

      <div className="pt-1 mr-[34px] text-zinc-500">
        پرداخت آنلاین با تمامی کارت‌های بانکی
      </div>

      <div className="pt-2 mr-8">
        <img src={banksIcon} alt="banks-icon" className="w-36" />
      </div>
    </div>
  );
};

export default InternetPay;
